import React, {useEffect, useState} from 'react';
import AdminDonations from 'components/admin/AdminDonations';
import LabeledInputWithDropdown from './LabeledInputWithDropdown';

const AdminCharityForm = () => {
    const [charityLinkId, setCharityLinkId] = useState('');
    const [charityName, setCharityName] = useState('');
    const [adminCategory, setAdminCategory] = useState('');
    const [amount, setAmount] = useState('');
    const [reason, setReason] = useState('');
    const [isPubliclyVisible, setIsPubliclyVisible] = useState(true);
    const [response, setResponse] = useState('');
    const [userId, setUserId] = useState('');

    const [categories, setCategories] = useState([]);
    const [charityNames, setCharityNames] = useState([]);
    const [rejectionReasons, setRejectionReasons] = useState([]);

    useEffect(() => {
        fetch('/api/admin/charity-categories')
            .then(res => res.json())
            .then(data => setCategories(data))
            .catch(console.error);

        fetch('/api/admin/charityNames')
            .then(res => res.json())
            .then(data => setCharityNames(data))
            .catch(console.error);

        fetch('/api/admin/charity-rejection-reasons')
            .then(res => res.json())
            .then(data => setRejectionReasons(data))
            .catch(console.error);
    }, []);

    const handlePost = async (url, body) => {
        try {
            const res = await fetch(url, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(body),
            });
            const text = await res.text();
            setResponse(text || 'Success');
        } catch (e) {
            setResponse(`Error: ${e.message}`);
        }
    };

    return (
        <div style={{border: '1px solid #ccc', padding: '10px', userSelect: 'text', position: 'relative'}}>
            <h2>Charity Approval/Reject</h2>

            <label>Charity Link ID</label>
            <input
                placeholder="Charity Link ID"
                value={charityLinkId}
                onChange={e => setCharityLinkId(e.target.value)}
                style={{display: 'block', margin: '5px 0', width: '100%'}}
            />

            <LabeledInputWithDropdown
                label="Charity Name"
                value={charityName}
                setValue={setCharityName}
                options={charityNames}
                isValid={charityNames.includes(charityName)}
            />

            <LabeledInputWithDropdown
                label="Admin Category"
                value={adminCategory}
                setValue={setAdminCategory}
                options={categories}
                isValid={categories.includes(adminCategory)}
            />

            <label>Amount (approve)</label>
            <input
                placeholder="Amount (approve)"
                value={amount}
                onChange={e => setAmount(e.target.value)}
                style={{display: 'block', margin: '5px 0', width: '100%'}}
            />

            <LabeledInputWithDropdown
                label="Reason (reject)"
                value={reason}
                setValue={setReason}
                options={rejectionReasons}
                isValid={rejectionReasons.includes(reason)}
            />

            <label style={{display: 'block', margin: '5px 0'}}>
                <input
                    type="checkbox"
                    checked={isPubliclyVisible}
                    onChange={e => setIsPubliclyVisible(e.target.checked)}
                />{' '}
                Publicly Visible
            </label>

            <div style={{marginTop: '10px'}}>
                <button
                    onClick={() =>
                        handlePost('/api/admin/charity/approve', {
                            charityLinkId,
                            amount,
                            charityName,
                            adminCategory,
                            isPubliclyVisible,
                        })
                    }
                    style={{marginRight: '10px'}}
                >
                    Approve
                </button>
                <button
                    onClick={() =>
                        handlePost('/api/admin/charity/reject', {
                            charityLinkId,
                            reason,
                            charityName,
                            adminCategory,
                            isPubliclyVisible,
                        })
                    }
                >
                    Reject
                </button>
            </div>

            <textarea
                value={response}
                placeholder="Approve/Reject Response"
                readOnly
                rows={5}
                style={{marginTop: '10px', width: '100%'}}
            />

            <label>User ID</label>
            <input
                placeholder="User ID"
                value={userId}
                onChange={e => setUserId(e.target.value)}
                style={{display: 'block', margin: '5px 0', width: '100%'}}
            />
            <p>User id: {userId ? userId : 'All users'}</p>
            <AdminDonations userId={userId}/>
        </div>
    );
};

export default AdminCharityForm;
